module.exports = __webpack_public_path__ + "img/female_4.0bdcaa8b.png";